// Modules
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

// Rxjs
import { of } from 'rxjs';
import { map, exhaustMap, catchError } from 'rxjs/operators';

// Store - Actions
import * as ViewProfileActions from '@store/actions/view-profile.actions';

// Services
import { ViewProfileService } from '@services/view-profile/view-profile.service';

@Injectable({
  providedIn: 'root',
})
export class ViewProfileEffects {
  // Constructor
  constructor(
    private _actions$: Actions,
    private _viewProfileService: ViewProfileService
  ) {}

  getUserProfile$ = createEffect(() =>
    this._actions$.pipe(
      ofType(ViewProfileActions.getUserProfileRequested),
      exhaustMap(() =>
        this._viewProfileService.getUserProfile().pipe(
          map(response =>
            ViewProfileActions.getUserProfileResponse({
              payload: response,
            })
          ),
          catchError(() =>
            of(ViewProfileActions.getUserProfileResponse({ payload: null }))
          )
        )
      )
    )
  );
}
